import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'No Sites Available',
  description:
    'You are not assigned to any Sites yet. Contact your administrator to be assigned to a Site.',
})
